
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member/terms",
      function () {
        return require("private-next-pages/member/terms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/member/terms"])
      });
    }
  